<template>
  <app-layout>
    <user-data-table :title="$t('Usuarios')" profile="customer"></user-data-table>
  </app-layout>
</template>
<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import UserDataTable from '../components/profiles/UserDataTable.vue';
export default {
  components: {
    AppLayout,
    UserDataTable,
  },
};
</script>
